



















































































































































import { defineComponent, reactive, toRefs, onMounted, ref } from '@vue/composition-api'
import * as Common from "../../commons/common"
import http from "../../plugins/http"
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import AlertArea from "../../components/AlertArea.vue"
import CustomConfirmModal from "../../components/CustomConfirmModal.vue"
import { LessonClass, Lesson } from "../../modules/teacher/LessonClassEdit"

export interface Data {
  lesson_class_id: string
  lessonClass: LessonClass | null
  lesson: Lesson
  errors: string[]
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
    'date-time-picker' : VueCtkDateTimePicker,
  },
  setup(props, context){

    const customConfirmModalRef = ref<InstanceType<typeof CustomConfirmModal>>();

    const state = reactive<Data>({
      lesson_class_id: null,
      lessonClass: null,
      lesson: null,
      errors: [],
    });

    const updateClick = async () => {
      state.errors = [];

      if(!state.lessonClass.lesson_class_no){
        state.errors.push("回次を入力してください。");
      }else if(!new RegExp(/^[0-9]+$/).test(state.lessonClass.lesson_class_no)){
        state.errors.push("回次は半角整数で入力してください。");
      }

      if(state.errors.length > 0){
        window.scroll({top: 0, behavior: 'smooth'});
        return;
      }

      if(state.lessonClass.requiresFollowUpSetting){
        // 得点枠の再設定が必要な場合に注意を促す確認メッセージを表示
        customConfirmModalRef.value.show();
      }else if(window.confirm("講座情報を更新します。よろしいですか？")){
        await update();
      }
    }

    const update = async () => {

      customConfirmModalRef.value.hide();

      context.root.$store.dispatch("showOverlay");
      
      await http.post(`/api/teacher/lesson_class_edit/update/${state.lesson_class_id}`, {lesson_class: state.lessonClass}).then(response => {
        alert("処理が完了しました。");
        window.history.back();
      })
      .catch(async error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
        window.scroll({top: 0, behavior: 'smooth'});
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      state.lesson_class_id = context.root.$route.params.lesson_class_id;
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      await http.get(`/api/teacher/lesson_class_edit?lesson_class_id=${state.lesson_class_id}`).then(response => {
        state.lessonClass = new LessonClass(response.data.lesson_class);
        state.lesson = response.data.lesson;
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    });

    return {
      ...toRefs(state),
      customConfirmModalRef,
      updateClick,
      update,
    }
  },
})
